import { Money } from "../ui";

export function PriceTag({ minor }: { minor?: number | null }) {
	return <Money minor={minor ?? null} className="text-sm" />;
}
